module.exports = __webpack_public_path__ + "img/ez-slot-category-new-released-mobile.43173941.png";